import React from 'react';

// Shown when the client has completed shops but none on a Finalized or Paid invoice yet. The tab is offered from the
// completed shops while the history only counts invoiced ones, so this says why it is empty: the client is between
// the first step and the second.
const STEPS = [
  { icon: 'fa-solid fa-clipboard-check', label: 'Shops completed', state: 'done' },
  { icon: 'fa-solid fa-file-invoice-dollar', label: 'Invoice finalized or paid', state: 'waiting' },
  { icon: 'fa-solid fa-chart-line', label: 'Pricing history', state: 'next' },
];

export default function ClientPricingHistoryNothingInvoiced() {
  return (
    <div className='empty-state'>
      <ol className='cph-steps'>
        {STEPS.map((step) => (
          <li
            key={step.label}
            className={`cph-step ${step.state}`}
          >
            <span className='cph-step-icon'>
              <i className={step.icon} />
            </span>
            <span className='cph-step-label'>{step.label}</span>
          </li>
        ))}
      </ol>
      <b>Nothing invoiced yet</b>
      <span>
        This client has completed shops, but none of them is on a finalized or paid invoice yet. The history fills in as
        the invoices are finalized.
      </span>
    </div>
  );
}
